<template>
  <ModalBase :name="$options.name" @close="$emit('close')" title="Bidding history">
    <template #body>
      <UtilListingOverviewDetails :details="modalData.details.bidding" detail-class="text-xl font-extrabold" />

      <div class="mt-4 space-y-4">
        <span class="block text-lg font-extrabold">All bids</span>

        <div class="relative overflow-scroll border rounded-lg">
          <table class="w-full">
            <thead class="sticky top-0 border-b z-1">
              <tr class="text-left bg-gray-lightest">
                <th class="px-4 py-1">Bidder</th>
                <th class="px-4 py-1">Bid amount</th>
                <th class="px-4 py-1">Placed</th>
              </tr>
            </thead>
            <tbody class="divide-y">
              <tr v-for="(bid, i) in bids" :key="`bid-${i}`" class="font-medium text-left">
                <td class="px-4 py-1">
                  {{
                    bid.user.userRef
                      ? formatUserName(bid.user, { lastNameInitial: true, placeholder: 'Anonymous' })
                      : ''
                  }}
                </td>

                <td class="px-4 py-1">
                  <div class="flex items-center space-x-2">
                    <span>{{ formatCurrency(bid.price) }}</span>

                    <UtilTag
                      v-if="bid.price === auction.priceReserve"
                      class="inline-block text-white bg-brand-darker"
                    >
                      <FontAwesomeIcon :icon="faCheck" />
                      Reserve Met
                    </UtilTag>

                    <UtilTag
                      v-if="i === 0 && bids.length > 1 && bid.price === bids[1].price"
                      class="inline-block text-white bg-information"
                    >
                      <FontAwesomeIcon :icon="faInfoCircle" />
                      Bid first
                    </UtilTag>
                  </div>
                </td>

                <td class="px-4 py-1">
                  {{ $date.utc(bid.created).format('Do MMM HH:mm') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <template #footer>
      <UtilButton @click="$emit('close')" block color="secondary">Close</UtilButton>
    </template>
  </ModalBase>
</template>

<script>
import { faCheck, faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import ModalBase from '@/components/modals/ModalBase'
import UtilListingOverviewDetails from '@/components/utils/listing/UtilListingOverviewDetails'
import UtilButton from '@/components/utils/UtilButton'
import UtilTag from '@/components/utils/UtilTag'
import { formatCurrency } from '@/lib/helpers/transform'

export default {
  name: 'ModalAuctionBids',
  components: {
    ModalBase,
    UtilListingOverviewDetails,
    UtilButton,
    UtilTag
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formatCurrency,
      faCheck,
      faInfoCircle
    }
  },
  computed: {
    auction() {
      return this.modalData.auction
    },
    bids() {
      return this.modalData.bids || []
    },
    confirm() {
      return [
        { label: 'Your bid', value: formatCurrency(this.bid.price), disabled: !!this.bid.max },
        { label: 'Your next bid', value: formatCurrency(this.bid.price), disabled: !this.bid.max },
        { label: 'Your max bid', value: formatCurrency(this.bid.max), disabled: !this.bid.max }
      ].filter(item => item.disabled !== true)
    }
  },
  watch: {
    '$route.path'() {
      this.closeModal()
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },

    formatUserName(user = {}, options = {}) {
      const placeholder = options.placeholder
      const lastNameInitial = options.lastNameInitial

      let userName = ''

      if (lastNameInitial) {
        userName = `${user.firstName} ${user.lastName?.charAt(0)}`
      } else {
        userName = `${user.firstName} ${user.lastName}`
      }

      return userName.trim() || placeholder
    }
  }
}
</script>
